// import config from 'config';
import axios from 'axios';
import { handleResponse } from './http-utils';

export const refITServiceStateService = {
    getByAccount,
    getById,
    add,
    update,
    deleteEntity
};

function getByAccount(accountId) {
    // return axios.get(`/areas/?accountId=${accountId}`).then(handleResponse);
    return axios.get(`/refITServiceStates/`).then(handleResponse);
}

function getById(id) {
    return axios.get(`/refITServiceStates/${id}`).then(handleResponse);
}

function add(refITServiceState) {
    return axios.post('/refITServiceStates', refITServiceState).then(handleResponse);
}

function update(refITServiceState) {
    return axios.put(`/refITServiceStates/${refITServiceState.refITServiceStateId}`, refITServiceState).then(handleResponse);
}

function deleteEntity(refITServiceState) {
    return axios.delete(`/refITServiceStates/${refITServiceState.refITServiceStateId}`).then(handleResponse);
}
